var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcScoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "74F3244B-D528-4E5B-A274-755D458BB470") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,5.95833333 C11,5.95833333 11.8472222,6.30138889 12.5416667,6.9875 C13.2546296,7.67361111 13.6111111,8.50416667 13.6111111,9.47916667 C13.6111111,10.4541667 13.2546296,11.2847222 12.5416667,11.9708333 C11.8472222,12.6569444 11,13 10,13 C9,13 8.14814815,12.6569444 7.44444444,11.9708333 C6.74074074,11.2847222 6.38888889,10.4541667 6.38888889,9.47916667 C6.38888889,8.50416667 6.74074074,7.67361111 7.44444444,6.9875 C8.14814815,6.30138889 9,5.95833333 10,5.95833333 Z M19.9500208,9.07431271 L19.9500208,9.1580756 C19.9916701,9.59085052 20.0072886,10.0131551 19.9968763,10.4249893 L19.977787,10.8333333 L17.7287241,10.6518471 C17.7495488,10.3167955 17.7521519,9.97650881 17.7365334,9.6309869 L17.714841,9.28371993 L17.714841,9.26975945 L19.9500208,9.07431271 Z M0.0416493128,9.0882732 L2.20741358,9.26975945 C2.17964737,9.604811 2.1753089,9.94509772 2.19439817,10.2906196 L2.22129668,10.6378866 L0.0416493128,10.8333333 C-0.0138831043,10.2376861 -0.0138831043,9.65599943 0.0416493128,9.0882732 Z M0.916284881,5.76567869 L2.87380258,6.68707045 C2.73497154,6.99420103 2.61696515,7.30918439 2.51978342,7.63202051 L2.42954325,7.95747423 L0.319311398,7.3850945 C0.467397843,6.82667526 0.666389005,6.28686999 0.916284881,5.76567869 Z M17.0068027,6.60330756 L19.047619,5.65399485 C19.2211579,6.04488832 19.373872,6.44886974 19.5057615,6.86593911 L19.6307094,7.28737113 L17.4788283,7.87371134 C17.3885881,7.54564003 17.2775233,7.2254215 17.1456338,6.91305573 L17.0068027,6.60330756 L19.047619,5.65399485 Z M2.88768569,2.94566151 L4.42871026,4.48131443 C4.28062381,4.63022623 4.13716507,4.78379152 3.99833403,4.94201031 C3.89343946,5.07230813 3.79471516,5.20053774 3.70216114,5.32669912 L3.5679578,5.51439003 L1.79092045,4.27190722 C1.9575177,4.02992554 2.13799806,3.79259737 2.33236152,3.55992268 C2.51746957,3.34586197 2.70257763,3.14110825 2.88768569,2.94566151 Z M16.9512703,2.82001718 C17.3862742,3.23883162 17.7796289,3.67626002 18.1313342,4.13230241 L18.1313342,4.13230241 L16.2987644,5.41666667 C16.0211023,5.05369416 15.715674,4.70933562 15.3824795,4.38359107 L15.3824795,4.38359107 Z M5.66430654,0.935352234 L6.59447452,2.91774055 C6.28210468,3.05734536 5.98535333,3.22050848 5.70422046,3.40722992 L5.42829377,3.60180412 L4.17881438,1.81486254 C4.65083993,1.47050401 5.14600398,1.17733391 5.66430654,0.935352234 Z M14.0635846,0.823668385 C14.5911426,1.05634307 15.095562,1.34951317 15.576843,1.70317869 L15.576843,1.70317869 L14.3273636,3.51804124 C13.9386367,3.23883162 13.5406544,3.00615693 13.1334166,2.82001718 L13.1334166,2.82001718 Z M8.94071914,0.0418814433 L9.1350826,2.19179553 C8.788005,2.23367698 8.45654588,2.29388155 8.14070526,2.37240926 L7.8300708,2.45704467 L7.27474663,0.362972509 C7.8023046,0.21406071 8.35762877,0.107030355 8.94071914,0.0418814433 Z M10.6761072,0 C11.2591976,0.0372279496 11.8330325,0.12564433 12.3976121,0.265249141 L12.3976121,0.265249141 L11.8422879,2.35932131 C11.407284,2.24763746 10.958397,2.18248855 10.4956268,2.16387457 L10.4956268,2.16387457 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8-honest-conversations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.4.1a-UCAP-AdvisorCenter-HonestConversations-Single-Entry-ScoreHistory-Rescoring",
    transform: "translate(-432.000000, -113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal",
    transform: "translate(420.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box/title-7.-Components/Title-Bar/Regular/Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDBC-Icon-5.-Icons/General/score",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(2.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#D2D2D2",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color-1.-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#8A8888"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -5.000000)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScoreIcon);
export default __webpack_public_path__ + "static/media/ic_score-icon.a9a52e6d13d887a8976bdc4361a190e4.svg";
export { ForwardRef as ReactComponent };